import React from 'react'
import { PageHeader, Panel, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import ActivityEditor from './ActivityEditor.jsx'
import { updateActivity } from '../ducks/activities'
import { docPageStyle } from '../containers/PageStyles'
import { getText } from '../lib/text.js'

import {
  getActivityForUrl, getReadyState, getCities, getCitiesIdList, getFromQuery, getActivityTags
} from '../selectors'

import "./Activity.less"

/** Page
 *
 */

type Props = {
  ready: boolean,
  activity: Object,
  routeParams: {id: string},
  onChange: (string, Object) => void
}

class Activity extends React.PureComponent
{
  props : Props

  render() {
    const { ready, activity, routeParams, onChange, backLink } = this.props
    const { id } = routeParams
    const a = activity

    if (!ready || !a) return <p>Loading...</p>

    return (
      <div className="activity-page" style={docPageStyle({maxWidth: 1024})}>

        <Link to={backLink} style={{fontWeight: "bold", fontSize: "15px"}}>
          <Glyphicon glyph="arrow-left" /> {getText("Volver a la lista")}
        </Link>

        {
          a.deleted && (
            <Panel className="deleted-panel" bsStyle="danger">
              <Panel.Heading><Panel.Title>{"⚠️  Actividad eliminada"}</Panel.Title></Panel.Heading>
              <Panel.Body>{(new Date(a.deleted)).toLocaleString()}</Panel.Body>
            </Panel>
          )
        }

        <PageHeader className="header">
          <div className="left">
            {a.name} <small>{a.title}</small>
          </div>
          <div className="right">
            <Link to={`/private/log/activities/${a._id}`} className="log-link">
              <Glyphicon glyph="list" /> Ver log
            </Link>
          </div>
        </PageHeader>

        <ActivityEditor
          activity={a}
          onChange={changes => onChange(id, changes)}
          Cities={this.props.Cities}
          citiesList={this.props.citiesList}
          tags={this.props.tags}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  ready: getReadyState(state, props),
  activity: getActivityForUrl(state, props),
  Cities: getCities(state, props),
  citiesList: getCitiesIdList(state, props),
  tags: getActivityTags(state, props),

  backLink: getFromQuery(state, props)("back") || "/private/activities",
})

const mapDispatchToProps = dispatch => ({
  onChange: (id, changes) => dispatch(updateActivity(id, changes))
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(Activity)
